export default __webpack_public_path__ + "static/media/image6.2f24b7e3.png";